module.exports = __webpack_public_path__ + "img/django.eac2f078.png";